import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {AbstractCrudService} from '../shared/abstract-crud.service';
import {Linking} from './linking.model';

/**
 * Service for interacting with Linkings.
 */
@Injectable()
export class LinkingCrudService extends AbstractCrudService<Linking> {
  /**
   * URL for current model, override url from superclass
   * @type {string}
   */
  protected url = environment.regoApiURL + 'linkings';

  private linkings: Promise<Linking[]>;

  /**
   * Default constructor
   * @param {HttpClient} http - refined http service, automatically adds authentication token
   */
  constructor(protected http: HttpClient) {
    super(http);
  }

  private async getLinkings(): Promise<Linking[]> {
    if (!this.linkings) {
      this.linkings = this.list().then(result => {
        if (result.data) {
          return result.data;
        }
        console.warn('No linkings found');
        return [];
      }).catch(err => {
        console.error('Error loading linkings', err);
        return [];
      });
    }
    return this.linkings;
  }

  /**
   * find source system identifier that is linked to rego identifier.
   * @param regoId
   * @param sourceSystem
   */
  public async getLinkingsForRegoId(regoId: string, sourceSystem: string): Promise<Linking[]> {
    return (await this.getLinkings())
      .filter(o => `${o.regoId}` === `${regoId}` && `${o.sourceSystem}` === `${sourceSystem}`);
  }

  public async getLinkingsForSourceId(sourceId: string | number): Promise<Linking[]> {
    return (await this.getLinkings())
      .filter(o => `${o.sourceId}` === `${sourceId}`);
  }

  public async getSourceIdsForRegoId(regoId: string | number, sourceSystem?: string): Promise<Set<string>> {
    return new Set(
      (await this.getLinkings())
        .filter(o => o.regoId.toString() === regoId.toString() && (sourceSystem === undefined || o.sourceSystem === sourceSystem))
        .map(linking => linking.sourceId)
    );
  }
}
